// extracted by mini-css-extract-plugin
module.exports = {"component":"MobileSplash_component__3c-28","load":"MobileSplash_load__3d_Wq"};